import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import store from "@/store";

const getBookings = () =>
  instance.get(
    `${apiUrls.BOOKING_LIST}?branch=${store.getters.selectedBranch.id}`
  );

const cancelBooking = (payload) =>
  instance.post(apiUrls.CANCEL_BOOKING, payload);

const getAppointmentHistory = () =>
  instance.get(
    `${apiUrls.APPOINTMENT_HISTORY}?branch=${store.getters.selectedBranch.id}`
  );

const getPurchaseHistory = () =>
  instance.get(
    `${apiUrls.PURCHASE_HISTORY}?branch=${store.getters.selectedBranch.id}`
  );

export {
  getBookings,
  cancelBooking,
  getAppointmentHistory,
  getPurchaseHistory,
};
